<template>
  <div class="machine-form">

    <b-modal :active.sync="showAddCategoryModal">
      <form @submit.prevent="addCategory" class="box">
        <h2 class="title is-4">Add New Category</h2>
        <b-field>
          <b-input v-model="newCategory" />
        </b-field>
        <div class="buttons">
          <button type="submit" class="button is-info" :class="{'is-loading': submittingCategory}">Add Category</button>
          <button class="button" @click="showAddCategoryModal = false">Cancel</button>
        </div>
      </form>
    </b-modal>

    <div class="columns is-multiline">
      <div class="column is-half">
        <div class="box">
          <b-field label="Name">
            <b-input v-model="editMachine.name" aria-placeholder="name" />
          </b-field>

          <b-field label="Category">
            <b-field grouped>
              <b-select v-model="editMachine.category" placeholder="Select a category" expanded>
                <option v-for="cat in categories.values" :value="cat" :key="cat">{{ cat || 'None' }}</option>
              </b-select>
              <p class="control">
                <button class="button"><font-awesome-icon icon="plus" @click="showAddCategoryModal = true"/></button>
              </p>
            </b-field>
          </b-field>

          <b-field label="SMU" expanded>
            <b-field>
              <b-input type="number" v-model="editMachine.smu" placeholder="SMU" expanded />
              <b-select v-model="editMachine.units" placeholder="Units">
                <option value="km">km</option>
                <option value="hours">hours</option>
              </b-select>
            </b-field>
          </b-field>

          <b-field label="Service interval" expanded>
            <b-field>
              <b-input type="number" v-model="editMachine.serviceInterval" placeholder="service interval" expanded />
              <p class="control">
                <span class="button is-static">{{ editMachine.units }}</span>
              </p>
            </b-field>
          </b-field>

          <b-field label="Service Warning" expanded>
            <b-field>
              <b-input type="number" v-model="editMachine.serviceWarning" placeholder="service warning" expanded />
              <p class="control">
                <span class="button is-static">{{ editMachine.units }} till next service</span>
              </p>
            </b-field>
          </b-field>

           <b-field label="Next Service" expanded>
            <b-field>
              <b-input type="number" v-model="editMachine.nextService" placeholder="next service" expanded />
              <p class="control">
                <span class="button is-static">{{ editMachine.units }}</span>
              </p>
            </b-field>
          </b-field>

           <b-field label="Next Service Type">
            <b-input type="text" v-model="editMachine.typeOfService" placeholder="service type" expanded />
          </b-field>

          <hr />
          <other-details-form :details="editMachine.otherDetails"></other-details-form>
        </div>
      </div>

      <div class="column is-half">
        <div class="box">
          <b-field label="Description / Notes">
            <b-input type="textarea" v-model="editMachine.description" placeholder="description / Notes" />
          </b-field>
          <b-checkbox v-model="editMachine.active">Active</b-checkbox>
          <br /><br />
          <b-checkbox v-model="editMachine.hireOut">Can be hired out</b-checkbox>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="box">
          <b-field label="Pre-Start Flick and Tick Check List">
            <b-select placeholder="Select a checklist" v-model="editMachine.preStartCheckListId" expanded>
              <optgroup label="Existing Check Lists">
                <option v-for="checkList in checkLists" :value="checkList._id" :key="checkList._id">
                  {{ checkList.name }}
                </option>
              </optgroup>
              <optgroup label="">
                <option :value="null">NONE</option>
              </optgroup>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>

     <div class="columns">
      <div class="column">
        <div class="box">
          <b-field label="Service Check List">
            <b-select placeholder="Select a checklist" v-model="editMachine.serviceCheckListId" expanded>
              <optgroup label="Existing Check Lists">
                <option v-for="checkList in checkLists" :value="checkList._id" :key="checkList._id">
                  {{ checkList.name }}
                </option>
              </optgroup>
              <optgroup label="">
                <option :value="null">NONE</option>
              </optgroup>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
         <b-notification v-if="errArr.length" type="is-danger">
           <p v-for="(msg, i) in errArr" :key="i">{{ msg }}</p>
         </b-notification>
        <div class="buttons">
          <button class="button" @click="$router.go(-1)">Back</button>
          <button class="button is-info" :class="{'is-loading': submitting}" @click="submit">{{ isNew ? 'Add' : 'Update' }} Machine</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import OtherDetailsForm from '@/components/OtherDetailsForm'
// import CheckListPreview from '@/components/CheckListPreview'
export default {
  name: 'MachineForm',
  components: {
    OtherDetailsForm
  },
  props: ['machine'],
  data () {
    return {
      editMachine: null,
      checkLists: null,
      errArr: [],
      submitting: false,
      checkList: null,
      showAddCategoryModal: false,
      categories: { values: [] },
      newCategory: '',
      submittingCategory: false
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    isNew () { return !this.machine },
    preStartCheckListId () { return this.editMachine ? this.editMachine.preStartCheckListId : null }
  },
  watch: {
    machine () { this.prepareMachine() },
    showAddCategoryModal () { this.newCategory = '' },
    preStartCheckListId () {
      this.checkList = null
      if (!this.preStartCheckListId) {
        return
      }
      if (this.preStartCheckListId === 'add') {
        this.$router.push('/admin/add-check-list')
        return
      }
      this.$firestore.collection('checkLists')
        .doc(this.preStartCheckListId)
        .get()
        .then(doc => {
          this.checkList = this.$utils.docToObj(doc)
        })
    }
  },
  created () {
    this.prepareMachine()

    this.subs.settings = this.$firestore.collection('checkLists')
      .onSnapshot(snapshot => {
        this.checkLists = this.$utils.snapshotToArr(snapshot)
      })

    this.subs.settings = this.$firestore.collection('settings')
      .doc('categories')
      .onSnapshot(snapshot => {
        this.categories = this.$utils.snapshotToObj(snapshot)
        this.categories.values.sort()
      })
  },
  methods: {
    addCategory () {
      if (!this.newCategory.length) {
        this.showAddCategoryModal = false
        return
      }
      this.submittingCategory = true
      this.$firestore.collection('settings')
        .doc('categories')
        .update({
          values: this.$firebase.firestore.FieldValue.arrayUnion(this.newCategory)
        })
        .then(resp => {
          this.editMachine.category = this.newCategory
          this.showAddCategoryModal = false
          this.submittingCategory = false
        })
        .catch(err => {
          this.showAddCategoryModal = false
          this.submittingCategory = false
          console.log('ERROR adding category', err)
        })
    },
    validate () {
      this.errArr = []
      this.editMachine.name = this.editMachine.name.trim()
      this.editMachine.typeOfService = this.editMachine.typeOfService.trim()
      this.editMachine.smu = Number(this.editMachine.smu)
      this.editMachine.serviceInterval = Number(this.editMachine.serviceInterval)
      this.editMachine.serviceWarning = Number(this.editMachine.serviceWarning)
      this.editMachine.nextService = Number(this.editMachine.nextService)

      if (!this.machine || (this.editMachine.smu !== this.machine.smu)) {
        this.editMachine.timestampSmuUpdated = this.$moment().unix()
      }

      if (!this.editMachine.name.length) {
        this.errArr.push('Please enter a name')
      }
      return this.errArr.length === 0
    },
    submit () {
      if (!this.validate() || this.submitting) {
        return
      }
      this.submitting = true
      if (this.isNew) {
        this.$firestore.collection('machines')
          .add(this.editMachine)
          .then(this.submitComplete)
          .catch(this.submitError)
      } else {
        delete this.editMachine._id
        this.$firestore.collection('machines')
          .doc(this.machine._id)
          .set(this.editMachine)
          .then(this.submitComplete)
          .catch(this.submitError)
      }
    },
    submitComplete (resp) {
      this.$toast.open({
        message: `Machine ${this.isNew ? 'Added' : 'Updated'}`,
        type: 'is-info'
      })
      this.$emit('submitted', this.isNew ? resp.id : this.machine._id)
      this.submitting = false
    },
    submitError (err) {
      this.submitting = false
      this.errArr.push(err.toString())
    },
    prepareMachine () {
      this.editMachine = Object.assign(this.getBlankMachine(), this.machine || {})
    },
    getBlankMachine () {
      return {
        user: `${this.user.firstName} ${this.user.lastName}`,
        userId: this.user.uid,
        name: '',
        category: null,
        smu: null,
        units: 'km',
        serviceInterval: null,
        serviceWarning: 0,
        nextService: null,
        typeOfService: '',
        description: '',
        preStartCheckListId: null,
        serviceCheckListId: null,
        active: true,
        otherDetails: [],
        timestampSmuUpdated: 0
      }
    }
  }
}
</script>

<style>

 .machine-form .repair .header {
   font-weight: bold;
   margin-top: -5px;
   font-size: 0.8em;
   padding-bottom: 10px;
 }
</style>
